module.exports = __webpack_public_path__ + "img/doc-1.d28912ff.jpg";